import React from "react";
import { motion } from "framer-motion";
import Section from "./hoc/Section";

// Animation Variants
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const fadeInY = {
  hidden: { opacity: 0, y: 60 },
  show: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const fadeInX = {
  hidden: { opacity: 0, x: -60 },
  show: { opacity: 1, x: 0, transition: { duration: 1.2 } },
};

const boxFade = {
  hidden: { opacity: 0, scale: 0.9 },
  show: { opacity: 1, scale: 1, transition: { duration: 1.2 } },
};

const leftContent = {
  hidden: { opacity: 0, x: -80 },
  show: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const rightImage = {
  hidden: { opacity: 0, x: 80 },
  show: (i = 1) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.5,
      duration: 1,
    },
  }),
};

const Team = () => {
  return (
    <motion.section
      id="team"
      className="w-full min-h-screen text-white flex flex-col items-center py-0"
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.3 }}
    >
      {/* Heading */}
      <motion.h1
        className="text-5xl font-bold text-center"
        variants={fadeInY}
      >
        Team Members
      </motion.h1>

      {/* Paragraph under heading */}
      <motion.p
        className="text-sm sm:text-base text-gray-400 text-center mt-2 max-w-3xl px-4"
        variants={fadeInX}
      >
        Each team member is special for us. We believe that everyone possesses one or more qualities that we cultivate in order to create success stories for our clients.
      </motion.p>

      {/* Animated box */}
      <motion.div className="gradient-border mt-9" variants={boxFade}>
  <div className="gradient-border-inner max-w-7xl h-auto lg:h-[500px] md:h-[500px] sm:h-[400px] rounded-lg overflow-hidden">
    <div className="flex flex-col lg:flex-row h-full">
      {/* Left content */}
      <motion.div
        className="flex-1 px-6 py-2 md:py-20 sm:py-6"
        variants={leftContent}
      >
        <h2 className="text-xl font-semibold mb-3 sm:mb-2">Who we are?</h2>
        <p className="text-sm text-gray-400 mb-3 sm:mb-2">
          We are a group of professional engineers and marketers who founded
          this company with the goal of providing clients with affordable,
          high-quality services.
        </p>
        <p className="text-sm text-gray-400 mb-3 sm:mb-2">
          We specialize in technologies like Solidity, NodeJS/NestJS, ReactJS,
          Angular, PHP Laravel, WordPress, ASP.NET, plus databases.
        </p>
        <p className="text-sm text-gray-400 mb-3 sm:mb-2">
          Domain experience includes DeFi, Insurance, E-commerce, etc.
        </p>
        <p className="text-sm text-gray-400">
          We don’t want to brag, but keep an eye on this section for success
          stories.
        </p>
        <a
          href="#contact"
          className="inline-block mt-5 px-6 py-2 rounded-full bg-gradient-to-r from-[#722bff] to-[#cc97f4] font-semibold hover:opacity-90 transition"
        >
          Contact&nbsp;Us
        </a>
      </motion.div>

      {/* Right image grid */}
      <div className="flex-1 p-6 sm:p-4">
  {/* hide on small, show from sm and above */}
  <div className="hidden sm:grid grid-cols-2 gap-4 h-full">
    <div className="flex flex-col gap-4">
      <motion.img
        custom={1}
        variants={rightImage}
        src="https://images.pexels.com/photos/13801640/pexels-photo-13801640.jpeg?auto=compress&cs=tinysrgb&w=800"
        alt="img1"
        className="w-full h-[200px] md:h-[210px] rounded-md object-cover"
      />
      <motion.img
        custom={2}
        variants={rightImage}
        src="https://images.pexels.com/photos/8145334/pexels-photo-8145334.jpeg?auto=compress&cs=tinysrgb&w=800"
        alt="img2"
        className="w-full h-[200px] md:h-[210px] rounded-md object-cover"
      />
    </div>

    <motion.img
      custom={3}
      variants={rightImage}
      src="https://images.pexels.com/photos/7793193/pexels-photo-7793193.jpeg?auto=compress&cs=tinysrgb&w=800"
      alt="img3"
      className="w-full h-[200px] md:h-[250px] rounded-md object-cover mt-18"
    />
  </div>
</div>

    </div>
  </div>
</motion.div>
    </motion.section>
  );
};

export default Section(Team, "team");
